export type Bool = 'Y' | 'N';
export type DateString = string;

export type DatePeriod = {
  startDateTime: DateString;
  endDateTime: DateString;
};

export type Link = {
  link: string;
  linkTarget: Bool;
};

export type Image = {
  imageMediasUrl: string;
  mobileImageMediasUrl: string;
};

export type ImageLinkDomainTimestamp = {
  staticResourceCDNDomain: string;
  lastModify: string;
};

export type ImageLink = Image & Link & DatePeriod;

export interface TextLayoutData<T = unknown> {
  adLayoutName: string;
  layoutData: {
    text: T[];
  };
}

export interface BannerLayoutData<T = unknown> {
  adLayoutName: string;
  layoutData: {
    banner: T[];
  };
}

export interface BaseResponse<T = unknown, C = string> {
  code: C;
  message: string;
  status: Bool;
  seoPojo: Record<string, string>;

  data: T;
}

export interface EdmData {
  spider_css: string;
  spider_js: string;
  spider_html: string;
  spider_url: string;
}

export type BreadcrumbData = {
  title: string;
  link: string;
};

type RtnSuccess = 1;
type RtnFail = -1;

export interface RtnResponse<T = unknown> {
  rtnCode: RtnSuccess | RtnFail;
  rtnMsg: string;
  data: T;
}

interface APIErrorPayload {
  message: string;
}

export class APIError extends Error {
  constructor(public payload: APIErrorPayload) {
    super(payload.message);
  }
}

export interface Param {
  cateid: string;
  sku: string;
  url: string;
  text: string;
  q: string;
  bwq: string;
  channel: string;
  shopcategory: string;
  needLogin: string;
  zoneRuleFlag: string;
  appPageName: string;
  params: string[];
}

export interface LinkApp {
  action: string;
  param: Param;
}

export interface Breadcrumb {
  categoryType: string;
  title: string;
  link: string;
  linkApp: LinkApp;
}

export interface NewCategoryData extends BaseResponse {
  apiBreadcrumb: Breadcrumb[];
  category: BaseResponse;
  categoryCode: string;
  categoryName: string;
  pageData?: {
    customizePageType?: string;
    categoryLevel?: string;
  };
}
